import { Printer } from '@bcyesil/capacitor-plugin-printer';
import { Capacitor } from '@capacitor/core';

export class BrouserPrinter {
    constructor() { }

    public async print(data: any, isUser = false) {
        let printableData = { ...data }; // Clone to make it extensible
        if (isUser) {
            printableData.qrCode = printableData?.employeeQR
            printableData.firstName = printableData?.firstname
            printableData.lastName = printableData?.lastname
        }
        try {
            // var visitorPassHTML = `<!DOCTYPE html>
            // <html lang="en">
            // <head>
            //     <meta charset="UTF-8">
            //     <meta name="viewport" content="width=device-width, initial-scale=1.0">
            //     <title>Visitor Pass</title>
            //     <style>
            //         /* Set the size of the page to 3.5x5 inches */
            //         body {
            //             font-family: 'Arial', sans-serif;
            //             text-align: center;
            //             margin: 0;
            //             padding: 0;
            //             background-color: #f4f4f9;
            //             display: flex;
            //             justify-content: center;
            //             align-items: center;
            //             width: 3.5in;
            //             height: 5in;
            //             box-sizing: border-box;
            //         }
            //         /* Make the container smaller than the page */
            //         .container {
            //             display: flex;
            //             flex-direction: column;
            //             align-items: center;
            //             justify-content: space-between;
            //             width: 3.1in;
            //             height: 4.5in;
            //             background-color: #ffffff;
            //             border-radius: 12px;
            //             padding: 15px;
            //             box-sizing: border-box;
            //             box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
            //         }
            //         .info-container {
            //             display: flex;
            //             flex-direction: column;
            //             justify-content: space-between;
            //             width: 100%;
            //             box-sizing: border-box;
            //             overflow: hidden;
            //             padding-right: 12px;
            //         }
            //         .header {
            //             font-size: 24px;
            //             font-weight: bold;
            //             color: #4a4a4a;
            //             margin-bottom: 10px;
            //             text-transform: uppercase;
            //         }
            //         .info {
            //             font-size: 14px;
            //             color: #555555;
            //             margin-bottom: 8px;
            //         }
            //         /* Bold only the keys */
            //         .info span.key {
            //             font-weight: bold;
            //             color: #000;
            //         }
            //         .logo {
            //             width: 0.6in;
            //             height: 0.6in;
            //             object-fit: contain;
            //             margin-bottom: 8px;
            //             align-self: center; /* Centers the logo */
            //         }
            //         /* Purpose and OTP Section */
            //         .purpose-otp-container {
            //             display: flex;
            //             flex-direction: column;
            //             gap: 10px;
            //             margin-top: auto;
            //             flex-shrink: 0;
            //             flex-grow: 0;
            //         }
            //         .purpose-otp-container .info {
            //             font-size: 14px;
            //             font-weight: normal;
            //         }
            //         .purpose-otp-container .info span.key {
            //             font-weight: bold;
            //         }
            //         /* Right Section: Side by Side Images */
            //         .right-section {
            //             display: flex;
            //             justify-content: center;  /* Centers the content horizontally */
            //             align-items: center;      /* Aligns the items vertically */
            //             width: 100%;
            //             margin-top: 12px;
            //             gap: 8px; /* Adds space between the photo and QR code */
            //         }

            //         .right-section img {
            //             width: 1.3in;
            //             height: 1.3in;
            //             object-fit: cover;
            //             border-radius: 12px;
            //             border: 2px solid #ddd;
            //             box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
            //         }
            //         @page {
            //             size: 3.5in 5in;
            //             margin: 0;
            //         }

            //         @media print {
            //             body {
            //                 margin: 0;
            //                 background: white !important;
            //                 -webkit-print-color-adjust: exact; /* Ensure colors show */
            //             }

            //             .container {
            //                 box-shadow: none;
            //             }

            //             button {
            //                 display: none;
            //             }
            //         }
            //     </style>
            // </head>
            // <body>
            //     <div class="container" id="visitorPass">
            //         <!-- Left Section: Logo, Info -->
            //         <div class="info-container">
            //             <img id="companyLogo" class="logo" src="https://portal.aumye.com/assets/logo/vertical_logo_gradient.png"
            //                 alt="Company Logo">
            //             <div class="header">${isUser ? 'User Pass' : 'Visitor Pass'}</div>
            //             <div class="info"><span class="key">Name:</span> <span id="visitorName">${data.firstName} ${data.lastName}</span></div>`

            // if (!isUser) {
            //     visitorPassHTML += `<div class="info"><span class="key">Host:</span> <span id="hostName">${data.hostName}</span></div>
            //                 <div class="info"><span class="key">Purpose:</span> <span id="visitPurpose">${data.purpose}</span></div>
            //                 <!-- Purpose and OTP Section --> 
            //                 <div class="purpose-otp-container">
            //                     <div class="info"><span class="key">Date:</span> <span id="visitDate">${new Date(data.visitDateTime).toLocaleDateString()}</span></div>
            //                     <div class="info"><span class="key">OTP:</span> <span id="otpCode">${data.securityKey}</span></div>
            //                 </div>`
            // }
            // visitorPassHTML += `</div>
            //         <!-- Right Section: Side-by-side Photos and QR Code -->
            //         <div class="right-section">
            //             <img id="visitorPhoto" class="photo" src="${data.profilePicture ? data.profilePicture : 'https://portal.aumye.com/assets/images/default_user.png'}" alt="Visitor Photo">
            //             <img id="qrCode" class="qr-code" src="${data.qrCode ? data.qrCode : ''}">
            //         </div>
            //     </div>
            // </body>
            // </html>
            // `

            var visitorPassHTML = `<!DOCTYPE html>
                <html lang="en">
                <head>
                <meta charset="UTF-8">
                <meta name="viewport" content="width=device-width, initial-scale=1.0">
                <title>Visitor Pass</title>
                <style>
                    /* 🖨️ Print Settings */
                    @page {
                        size: 3.5in 5in portrait;
                        margin: 0;
                        -webkit-print-color-adjust: exact !important;
                        print-color-adjust: exact !important;
                    }
                    @media print {
                        body {
                            margin: 30px !important;
                            -webkit-print-color-adjust: exact !important;
                            print-color-adjust: exact !important;
                            background: #fff !important;
                        }
                        .container {
                            box-shadow: none !important;
                            border: 2px solid #000 !important;
                        }
                    }
                    body {
                        font-family: 'Arial', sans-serif;
                        text-align: center;
                        margin: 0;
                        padding: 0;
                        background-color: #f5f5f5;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        width: 3.5in;
                        height: 5in;
                        box-sizing: border-box;
                    }
                    .container {
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        width: 3in;
                        height: 4.7in;
                        background-color: #ffffff;
                        border-radius: 12px;
                        padding: 15px;
                        box-sizing: border-box;
                        box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
                        overflow: hidden;
                        position: relative;
                    }
                    .header {
                        font-size: 26px;
                        font-weight: bold;
                        color: #333;
                        margin-bottom: 10px;
                        text-transform: uppercase;
                        text-align: center;
                        margin-top: 0;
                    }
                    .info-container {
                        width: 100%;
                        display: flex;
                        flex-direction: column;
                        gap: 10px;
                        font-size: 12px;
                        color: #555;
                        background-color: #f5f5f5;
                        padding: 10px;
                        border-radius: 8px;
                        margin-bottom: 10px;
                    }
                    .info {
                        display: flex;
                        justify-content: flex-start;
                        width: 100%;
                        font-size: 13px;
                    }
                    .info .key {
                        font-weight: bold;
                        color: #333;
                        flex-basis: 25%;
                        text-align: left;
                        padding-right: 10px;
                    }
                    .info .value {
                        color: #777;
                        flex-grow: 1;
                        text-align: left;
                    }
                    .logo {
                        width: 0.6in;
                        height: 0.6in;
                        object-fit: contain;
                        margin-bottom: 15px;
                    }
                    .right-section {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        width: 100%;
                        gap: 10px;
                        margin-top: 10px;
                    }
                    .image-slot {
                        width: 1.3in;
                        height: 1.3in;
                        object-fit: cover;
                        border-radius: 12px;
                        border: 2px solid #ddd;
                        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
                    }
                    .image-slot[src=""] {
                        display: none;
                    }
                    .right-section:has(img.image-slot[src=""]:only-child),
                    .right-section:has(img.image-slot:not([src]):only-child),
                    .right-section:has(img.image-slot:not(:nth-child(2))) {
                        justify-content: center;
                    }
                    .right-section:has(img[src=""]:first-child):has(img[src=""]:last-child) {
                        display: none;
                    }
                    @media (max-width: 400px) {
                        .info {
                            /*flex-direction: column;*/
                            align-items: flex-start;
                        }
                        /*.right-section {
                            flex-direction: column;
                        }*/
                        .image-slot {
                            margin-bottom: 10px;
                        }
                    }
                </style>
                </head>
                <body>
                <div class="container" id="visitorPass">
                    <img class="logo" src="https://portal.aumye.com/assets/logo/vertical_logo_gradient.png" alt="Company Logo">
                    <div class="header">${isUser ? 'User Pass' : 'Visitor Pass'}</div>
                    <div class="info-container">
                    <div class="info">
                        <span class="key">Name:</span>
                        <span class="value">${printableData.firstName} ${printableData.lastName}</span>
                    </div>`

            if (!isUser) {
                visitorPassHTML += `
                        <div class="info">
                            <span class="key">Host:</span>
                            <span class="value">${printableData.hostName}</span>
                        </div>
                        <div class="info">
                            <span class="key">Purpose:</span>
                            <span class="value">${printableData.purpose}</span>
                        </div>
                        <div class="info">
                            <span class="key">Date:</span>
                            <span class="value">${new Date(printableData.visitDateTime).toLocaleDateString()}</span>
                        </div>
                        <div class="info">
                            <span class="key">OTP:</span>
                            <span class="value">${printableData.securityKey}</span>
                        </div>`
            } else {
                const department = `<div class="info"><span class="key">Department:</span><span class="value">${printableData.employeeDepartment}</span></div>`
                visitorPassHTML += printableData.employeeDepartment ? department : '';
            }

            visitorPassHTML += `</div>
                    <div class="right-section">
                    <img class="image-slot" src="${printableData.profilePicture || 'https://portal.aumye.com/assets/images/default_user.png'}" alt="Visitor Photo">
                    <img class="image-slot" src="${printableData.qrCode || ''}" alt="QR Code">
                    </div>
                </div>
                </body>
                </html>
            `
            if (Capacitor.isNativePlatform()) {
                try {
                    await Printer.print({
                        content: visitorPassHTML,
                        orientation: "portrait"
                    });
                    console.log('Printed via native');
                } catch (err) {
                    console.error('Native print failed:', err);
                }
            } else {
                const iframe = document.createElement('iframe');
                iframe.style.display = 'none';
                document.body.appendChild(iframe);
                iframe.contentDocument?.open();
                iframe.contentDocument?.write(visitorPassHTML);
                iframe.contentDocument?.close();

                iframe.onload = () => {
                    iframe.contentWindow?.focus();
                    iframe.contentWindow?.print();
                    document.body.removeChild(iframe);
                };
            }
        } catch (error) {
            console.error('Error printing visitor pass:', error);
        }
    }
}